import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { pagesData } from '../data/pagesData';
import HeroSection from '../components/sections/HeroSection';
import VisionMissionSection from '../components/sections/VisionMissionSection';
import AboutPreview from '../components/sections/AboutPreview';
import ServicesSection from '../components/sections/ServicesSection';
import ServicesGridSection from '../components/sections/ServicesGridSection';
import ServicesCTASection from '../components/sections/ServicesCTASection';
import AboutHeroSection from '../components/sections/AboutHeroSection';
import AboutCompanyOverviewSection from '../components/sections/AboutCompanyOverviewSection';
import AboutQualitySafetySection from '../components/sections/AboutQualitySafetySection';
import AboutProjectManagementSection from '../components/sections/AboutProjectManagementSection';
import BusinessScopeSection from '../components/sections/BusinessScopeSection';
import AboutVisionMissionGoalsSection from '../components/sections/AboutVisionMissionGoalsSection';
import AboutCoreValuesSection from '../components/sections/AboutCoreValuesSection';
import AboutWhyUsSection from '../components/sections/AboutWhyUsSection';
import AboutTestimonialsSection from '../components/sections/AboutTestimonialsSection';
import AboutCTASection from '../components/sections/AboutCTASection';
import ProjectsHeroSection from '../components/sections/ProjectsHeroSection';
import ProjectsGridSection from '../components/sections/ProjectsGridSection';
import ContactHeroSection from '../components/sections/ContactHeroSection';
import ContactInfoSection from '../components/sections/ContactInfoSection';
import ImpactSection from '../components/sections/ImpactSection';
import ProjectsSection from '../components/sections/ProjectsSection';
import WhyChooseUs from '../components/sections/WhyChooseUs';
import NewsSection from '../components/sections/NewsSection';
import ContactCallout from '../components/sections/ContactCallout';
import MapSection from '../components/sections/MapSection';
// مكتبة السحب والإفلات
import { DragDropContext, Droppable, Draggable, DroppableProvided, DraggableProvided, DraggableStateSnapshot } from 'react-beautiful-dnd';
import { FaTimes } from 'react-icons/fa';
import SectionPropsEditor from '../components/editors/SectionPropsEditor';
import InlineEditor from '../components/editors/InlineEditor';
import AdminLayout from '../components/admin/AdminLayout';


// دالة لحفظ التغييرات في pagesData.ts
const saveToPagesData = (pageId: string, updatedSections: any[]) => {
  try {
    // تحديث pagesData في الذاكرة
    if (pagesData[pageId]) {
      pagesData[pageId].sections = updatedSections;
    }
    
    // في الإنتاج، هنا سيتم إرسال البيانات إلى API
    console.log('Saving to pagesData:', pageId, updatedSections);
    
    // حفظ البيانات في localStorage كبديل مؤقت للصفحات الحقيقية
    localStorage.setItem(`pageData_${pageId}`, JSON.stringify(updatedSections));
    
    // حفظ timestamp للتحديث
    localStorage.setItem(`pageData_${pageId}_timestamp`, Date.now().toString());
    
    // إضافة معلومات إضافية عن التحديث
    const updateInfo = {
      lastUpdated: new Date().toISOString(),
      sectionsCount: updatedSections.length,
      pageId: pageId
    };
    localStorage.setItem(`pageData_${pageId}_info`, JSON.stringify(updateInfo));
    
    // رسالة تأكيد للمستخدم
    console.log(`✅ تم حفظ التغييرات للصفحة ${pageId}. يمكنك الآن فتح الصفحة الحقيقية لرؤية التغييرات.`);
    
    // إضافة تأكيد إضافي للتأكد من الحفظ
    const savedData = localStorage.getItem(`pageData_${pageId}`);
    if (!savedData) {
      console.error('Failed to save data to localStorage');
      return false;
    }
    
    return true;
  } catch (error) {
    console.error('Error saving to pagesData:', error);
    return false;
  }
};

const sectionComponents: Record<string, React.ComponentType<any>> = {
  HeroSection,
  VisionMissionSection,
  AboutPreview,
  ServicesSection,
  ServicesGridSection,
  ServicesCTASection,
  AboutHeroSection,
  AboutCompanyOverviewSection,
  AboutQualitySafetySection,
  AboutProjectManagementSection,
  BusinessScopeSection,
  AboutVisionMissionGoalsSection,
  AboutCoreValuesSection,
  AboutWhyUsSection,
  AboutTestimonialsSection,
  AboutCTASection,
  ProjectsHeroSection,
  ProjectsGridSection,
  ContactHeroSection,
  ContactInfoSection,
  ImpactSection,
  ProjectsSection,
  WhyChooseUs,
  NewsSection,
  ContactCallout,
  MapSection,
};

const sectionLibrary = [
  { type: 'HeroSection', label: 'Hero Section' },
  { type: 'VisionMissionSection', label: 'Vision, Mission & Goals' },
  { type: 'AboutPreview', label: 'About Preview' },
  { type: 'ServicesSection', label: 'Services' },
  { type: 'ServicesGridSection', label: 'Services Grid' },
  { type: 'ServicesCTASection', label: 'Services CTA' },
  { type: 'AboutHeroSection', label: 'About Hero' },
  { type: 'AboutCompanyOverviewSection', label: 'About Company Overview' },
  { type: 'AboutQualitySafetySection', label: 'About Quality & Safety' },
  { type: 'AboutProjectManagementSection', label: 'About Project Management' },
  { type: 'BusinessScopeSection', label: 'Business Scope' },
  { type: 'AboutVisionMissionGoalsSection', label: 'About Vision Mission Goals' },
  { type: 'AboutCoreValuesSection', label: 'About Core Values' },
  { type: 'AboutWhyUsSection', label: 'About Why Us' },
  { type: 'AboutTestimonialsSection', label: 'About Testimonials' },
  { type: 'AboutCTASection', label: 'About CTA' },
  { type: 'ProjectsHeroSection', label: 'Projects Hero' },
  { type: 'ProjectsGridSection', label: 'Projects Grid' },
  { type: 'ContactHeroSection', label: 'Contact Hero' },
  { type: 'ContactInfoSection', label: 'Contact Info' },
  { type: 'ImpactSection', label: 'Impact' },
  { type: 'ProjectsSection', label: 'Projects' },
  { type: 'WhyChooseUs', label: 'Why Choose Us' },
  { type: 'NewsSection', label: 'News' },
  { type: 'ContactCallout', label: 'Contact Callout' },
  { type: 'MapSection', label: 'Map' },
];

const getDefaultProps = (type: string) => {
  // يمكن تخصيص default props لكل سكشن لاحقًا
  return {};
};

const AdminPageBuilder: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [sections, setSections] = useState<any[]>([]);
  const [language, setLanguage] = useState<'ar' | 'en'>('ar');
  const [isLoading, setIsLoading] = useState(true);
  const [pageTitle, setPageTitle] = useState('');
  const [preview, setPreview] = useState(false);
  const [editingIdx, setEditingIdx] = useState<number | null>(null);
  const [editProps, setEditProps] = useState<any>({});
  const [showPropsEditor, setShowPropsEditor] = useState(false);
  const [editingSectionType, setEditingSectionType] = useState('');
  const [showInlineEditor, setShowInlineEditor] = useState(false);
  const [inlineEditingData, setInlineEditingData] = useState<any>(null);

  useEffect(() => {
    if (id && pagesData[id as keyof typeof pagesData]) {
      const pageData = pagesData[id as keyof typeof pagesData];
      setSections(pageData.sections);
      setPageTitle(id);
      setIsLoading(false);
    }
  }, [id]);

  const onDragEnd = (result: any) => {
    if (!result.destination) return;
    
    const items = Array.from(sections);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    
    setSections(items);
    
    // حفظ التغييرات في pagesData
    if (id) {
      saveToPagesData(id, items);
    }
  };

  const handleAddSection = (type: string) => {
    const newSection = { type, props: getDefaultProps(type) };
    const updatedSections = [...sections, newSection];
    setSections(updatedSections);
    
    // حفظ التغييرات في pagesData
    if (id) {
      saveToPagesData(id, updatedSections);
    }
  };

  const handleDelete = (idx: number) => {
    if (window.confirm('هل أنت متأكد من حذف هذا القسم؟')) {
      const updatedSections = sections.filter((_, index) => index !== idx);
      setSections(updatedSections);
      
      // حفظ التغييرات في pagesData
      if (id) {
        const success = saveToPagesData(id, updatedSections);
        if (success) {
          alert(`✅ تم حذف القسم بنجاح!`);
          
          // إعادة تحميل الصفحة بعد ثانيتين
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else {
          alert('❌ حدث خطأ أثناء حفظ التغييرات');
        }
      }
    }
  };

  const handleEdit = (idx: number) => {
    setEditingIdx(idx);
    setEditProps(sections[idx].props);
    setEditingSectionType(sections[idx].type);
    setShowPropsEditor(true);
  };

  const handleInlineEdit = (idx: number) => {
    setEditingIdx(idx);
    setShowInlineEditor(true);
  };

  const handleSaveEdit = (newProps: any) => {
    if (editingIdx !== null) {
      const updatedSections = [...sections];
      updatedSections[editingIdx] = { ...updatedSections[editingIdx], props: newProps };
      setSections(updatedSections);
      
      // حفظ التغييرات في pagesData
      if (id) {
        saveToPagesData(id, updatedSections);
      }
    }
    setShowPropsEditor(false);
    setEditingIdx(null);
    setEditProps({});
  };

  const handleCancelEdit = () => {
    setShowPropsEditor(false);
    setShowInlineEditor(false);
    setEditingIdx(null);
    setEditProps({});
  };

  // دالة حذف عنصر من السكشن
  const handleDeleteElement = (elementKey?: string) => {
    if (editingIdx !== null && elementKey) {
      const updatedSections = [...sections];
      const currentSection = updatedSections[editingIdx];
      
      if (currentSection) {
        console.log('Deleting element:', elementKey, 'from section:', currentSection.type);
        
        // حذف العنصر بناءً على المفتاح
        if (elementKey.includes('.')) {
          // للبيانات المتداخلة مثل headline.ar أو points.0.ar
          const keys = elementKey.split('.');
          let current = currentSection.props;
          
          // الوصول إلى العنصر المراد حذفه
          for (let i = 0; i < keys.length - 1; i++) {
            const key = keys[i];
            const nextKey = keys[i + 1];
            
            if (!isNaN(parseInt(nextKey))) {
              // إذا كان المفتاح التالي رقم، فهذا مصفوفة
              if (!current[key] || !Array.isArray(current[key])) {
                current[key] = [];
              }
              current = current[key];
              i++; // تخطي المفتاح التالي لأنه رقم
            } else {
              if (!current[key]) {
                current[key] = {};
              }
              current = current[key];
            }
          }
          
          // حذف العنصر
          const lastKey = keys[keys.length - 1];
          if (!isNaN(parseInt(lastKey))) {
            // إذا كان المفتاح الأخير رقم، فهذا عنصر في مصفوفة
            const arrayKey = keys[keys.length - 2];
            const index = parseInt(lastKey);
            if (current[arrayKey] && Array.isArray(current[arrayKey])) {
              current[arrayKey].splice(index, 1);
              console.log('Deleted array element at index:', index);
            }
          } else {
            delete current[lastKey];
            console.log('Deleted property:', lastKey);
          }
        } else {
          // للبيانات البسيطة
          delete currentSection.props[elementKey];
          console.log('Deleted simple property:', elementKey);
        }
        
        setSections(updatedSections);
        
        // حفظ التغييرات في pagesData
        if (id) {
          const success = saveToPagesData(id, updatedSections);
          if (success) {
            alert(`✅ تم حذف العنصر "${elementKey}" بنجاح!`);
            
            // إعادة تحميل الصفحة بعد ثانيتين
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          } else {
            alert('❌ حدث خطأ أثناء حفظ التغييرات');
          }
        }
      }
    }
    
    setShowInlineEditor(false);
    setEditingIdx(null);
  };

  // دالة حذف عنصر من قائمة (مثل توصية، مشروع، خدمة)
  const handleDeleteListItem = (sectionIndex: number, listKey: string, itemIndex: number) => {
    if (window.confirm(`هل أنت متأكد من حذف العنصر رقم ${itemIndex + 1} من القائمة؟`)) {
      const updatedSections = [...sections];
      const currentSection = updatedSections[sectionIndex];
      
      if (currentSection.props[listKey] && Array.isArray(currentSection.props[listKey])) {
        currentSection.props[listKey].splice(itemIndex, 1);
        setSections(updatedSections);
        
        // حفظ التغييرات في pagesData
        if (id) {
          const success = saveToPagesData(id, updatedSections);
          if (success) {
            alert(`✅ تم حذف العنصر رقم ${itemIndex + 1} من القائمة بنجاح!`);
            
            // إعادة تحميل الصفحة بعد ثانيتين
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          } else {
            alert('❌ حدث خطأ أثناء حفظ التغييرات');
          }
        }
      }
    }
  };

  const handleSavePage = () => {
    // حفظ البيانات في pagesData
    if (id) {
      const success = saveToPagesData(id, sections);
      if (success) {
        // إظهار رسالة نجاح مع معلومات مفصلة
        const message = `✅ تم حفظ الصفحة بنجاح!

📄 الصفحة: ${pageTitle}
🔄 التغييرات: ${sections.length} قسم

🌐 لرؤية التغييرات:
• اضغط على زر "عرض الصفحة الحقيقية" في الأعلى
• أو افتح الرابط: http://localhost:3000/${id}
• أو اذهب إلى الصفحة من القائمة الرئيسية

💾 التغييرات محفوظة في localStorage وستظهر فوراً للزائرين.`;
        
        alert(message);
        
        // إضافة تأثير بصري للنجاح
        const saveButton = document.querySelector('[data-save-button]');
        if (saveButton) {
          saveButton.classList.add('bg-green-600');
          setTimeout(() => {
            saveButton.classList.remove('bg-green-600');
          }, 2000);
        }
      } else {
        alert('❌ حدث خطأ أثناء حفظ الصفحة. يرجى المحاولة مرة أخرى.');
      }
    } else {
      alert('❌ خطأ: لم يتم العثور على معرف الصفحة.');
    }
  };

  // زر معاينة بالحجم الكامل
  const handleFullPreview = () => {
    // حفظ البيانات مؤقتًا في localStorage (أو يمكن لاحقًا ربطها بـ API)
    localStorage.setItem('page-preview-data', JSON.stringify({ sections, language }));
    window.open(`/preview?page=${id}&lang=${language}`, '_blank');
  };

  // محرر خصائص بسيط (يمكن تطويره لاحقًا لكل سكشن)
  const renderEditForm = (type: string, props: any) => {
    if (type === 'HeroSection') {
      return (
        <div className="space-y-4">
          <label className="block">
            <span>العنوان الرئيسي (ar):</span>
            <input className="input" value={props.headline?.ar || ''} onChange={e => setEditProps({ ...props, headline: { ...props.headline, ar: e.target.value } })} />
          </label>
          <label className="block">
            <span>العنوان الرئيسي (en):</span>
            <input className="input" value={props.headline?.en || ''} onChange={e => setEditProps({ ...props, headline: { ...props.headline, en: e.target.value } })} />
          </label>
          <label className="block">
            <span>الوصف (ar):</span>
            <input className="input" value={props.subheadline?.ar || ''} onChange={e => setEditProps({ ...props, subheadline: { ...props.subheadline, ar: e.target.value } })} />
          </label>
          <label className="block">
            <span>الوصف (en):</span>
            <input className="input" value={props.subheadline?.en || ''} onChange={e => setEditProps({ ...props, subheadline: { ...props.subheadline, en: e.target.value } })} />
          </label>
        </div>
      );
    }
    // يمكن إضافة محررات مخصصة لكل سكشن لاحقًا
    return <div>لا يوجد محرر خصائص مخصص لهذا السكشن بعد.</div>;
  };

  return (
    <AdminLayout 
      language={language} 
      currentPage="pagebuilder"
      onSectionAdd={handleAddSection}
    >
      <div className="min-h-screen bg-gray-100 flex flex-col" dir={language === 'ar' ? 'rtl' : 'ltr'}>
        <div className="flex items-center justify-between bg-white shadow px-8 py-4 border-b sticky top-0 z-20">
          <div className="flex items-center gap-4">
            <h2 className="text-xl font-bold text-blue-900">
              {isLoading ? 'جاري التحميل...' : `محرر ${pageTitle} (${id})`}
            </h2>
            <button className={`px-3 py-1 rounded ${language === 'ar' ? 'bg-blue-700 text-white' : 'bg-gray-200'}`} onClick={() => setLanguage('ar')}>عربي</button>
            <button className={`px-3 py-1 rounded ${language === 'en' ? 'bg-blue-700 text-white' : 'bg-gray-200'}`} onClick={() => setLanguage('en')}>EN</button>
          </div>
          <div className="flex gap-2">
            <button onClick={handleFullPreview} className="bg-gray-800 text-white px-6 py-2 rounded-lg font-bold hover:bg-black transition">معاينة بالحجم الكامل</button>
            <button onClick={() => setPreview(!preview)} className="bg-yellow-500 text-white px-6 py-2 rounded-lg font-bold hover:bg-yellow-600 transition">{preview ? 'إغلاق المعاينة' : 'معاينة الصفحة'}</button>
            <button 
              onClick={handleSavePage} 
              data-save-button
              className="bg-blue-700 text-white px-6 py-2 rounded-lg font-bold hover:bg-blue-800 transition"
            >
              حفظ الصفحة
            </button>
            <button 
              onClick={() => {
                // فتح الصفحة الحقيقية في تبويب جديد
                window.open(`/${id}`, '_blank');
              }} 
              className="bg-green-600 text-white px-6 py-2 rounded-lg font-bold hover:bg-green-700 transition"
            >
              عرض الصفحة الحقيقية
            </button>
          </div>
        </div>
        
        <div className="flex-1 p-6">
          {isLoading ? (
            <div className="flex items-center justify-center h-64">
              <div className="text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-700 mx-auto mb-4"></div>
                <p className="text-gray-600">جاري تحميل بيانات الصفحة...</p>
              </div>
            </div>
          ) : preview ? (
            <div className="bg-white rounded-xl shadow p-0 min-h-screen">
              <div className={`min-h-screen ${language === 'ar' ? 'font-cairo' : 'font-montserrat'}`} dir={language === 'ar' ? 'rtl' : 'ltr'}>
                {sections.map((section, idx) => {
                  const SectionComponent = sectionComponents[section.type];
                  if (!SectionComponent) return null;
                  return <SectionComponent key={idx} language={language} {...section.props} />;
                })}
              </div>
            </div>
          ) : (
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="sections-droppable">
                {(provided: DroppableProvided) => (
                  <div ref={provided.innerRef} {...provided.droppableProps} className="space-y-6">
                    {sections.map((section, idx) => {
                      const SectionComponent = sectionComponents[section.type];
                      return (
                        <Draggable key={idx} draggableId={String(idx)} index={idx}>
                          {(provided: DraggableProvided, snapshot: DraggableStateSnapshot) => (
                            <div ref={provided.innerRef} {...provided.draggableProps} className={`bg-white rounded-xl shadow p-4 relative border-2 ${snapshot.isDragging ? 'border-blue-500' : 'border-transparent'}`}> 
                              <div className="flex items-center justify-between mb-2">
                                <span className="font-bold text-blue-700">{sectionLibrary.find(s => s.type === section.type)?.label || section.type}</span>
                                <div className="flex gap-2">
                                  <button onClick={() => handleInlineEdit(idx)} className="text-blue-600 font-bold">تعديل مباشر</button>
                                  <button onClick={() => handleEdit(idx)} className="text-green-600 font-bold">تعديل خصائص</button>
                                  <button onClick={() => handleDelete(idx)} className="text-red-600 font-bold">حذف</button>
                                  <span {...provided.dragHandleProps} className="cursor-move text-gray-400">↕</span>
                                </div>
                              </div>
                              <div className="opacity-60 pointer-events-none relative">
                                {SectionComponent && (
                                  <SectionComponent 
                                    language={language} 
                                    {...section.props}
                                    onDeletePoint={section.type === 'AboutWhyUsSection' ? 
                                      (index: number) => {
                                        const updatedSections = [...sections];
                                        const currentSection = updatedSections[idx];
                                        if (currentSection.props.points && Array.isArray(currentSection.props.points)) {
                                          currentSection.props.points.splice(index, 1);
                                          setSections(updatedSections);
                                          if (id) {
                                            saveToPagesData(id, updatedSections);
                                          }
                                        }
                                      } : undefined
                                    }
                                    onDeleteCard={section.type === 'VisionMissionSection' ? 
                                      (index: number) => {
                                        const updatedSections = [...sections];
                                        const currentSection = updatedSections[idx];
                                        if (currentSection.props.cards && Array.isArray(currentSection.props.cards)) {
                                          currentSection.props.cards.splice(index, 1);
                                          setSections(updatedSections);
                                          if (id) {
                                            saveToPagesData(id, updatedSections);
                                          }
                                        }
                                      } : undefined
                                    }
                                    onDeleteService={section.type === 'ServicesGridSection' ? 
                                      (index: number) => {
                                        const updatedSections = [...sections];
                                        const currentSection = updatedSections[idx];
                                        if (currentSection.props.services && Array.isArray(currentSection.props.services)) {
                                          currentSection.props.services.splice(index, 1);
                                          setSections(updatedSections);
                                          if (id) {
                                            saveToPagesData(id, updatedSections);
                                          }
                                        }
                                      } : undefined
                                    }
                                    onDeleteProject={section.type === 'ProjectsGridSection' ? 
                                      (index: number) => {
                                        const updatedSections = [...sections];
                                        const currentSection = updatedSections[idx];
                                        if (currentSection.props.projects && Array.isArray(currentSection.props.projects)) {
                                          currentSection.props.projects.splice(index, 1);
                                          setSections(updatedSections);
                                          if (id) {
                                            saveToPagesData(id, updatedSections);
                                          }
                                        }
                                      } : undefined
                                    }
                                    onDeleteValue={section.type === 'AboutCoreValuesSection' ? 
                                      (index: number) => {
                                        const updatedSections = [...sections];
                                        const currentSection = updatedSections[idx];
                                        if (currentSection.props.values && Array.isArray(currentSection.props.values)) {
                                          currentSection.props.values.splice(index, 1);
                                          setSections(updatedSections);
                                          if (id) {
                                            saveToPagesData(id, updatedSections);
                                          }
                                        }
                                      } : undefined
                                    }
                                    onDeleteTestimonial={section.type === 'AboutTestimonialsSection' ? 
                                      (index: number) => {
                                        const updatedSections = [...sections];
                                        const currentSection = updatedSections[idx];
                                        if (currentSection.props.testimonials && Array.isArray(currentSection.props.testimonials)) {
                                          currentSection.props.testimonials.splice(index, 1);
                                          setSections(updatedSections);
                                          if (id) {
                                            saveToPagesData(id, updatedSections);
                                          }
                                        }
                                      } : undefined
                                    }
                                    onDeleteArticle={section.type === 'NewsSection' ? 
                                      (index: number) => {
                                        const updatedSections = [...sections];
                                        const currentSection = updatedSections[idx];
                                        if (currentSection.props.articles && Array.isArray(currentSection.props.articles)) {
                                          currentSection.props.articles.splice(index, 1);
                                          setSections(updatedSections);
                                          if (id) {
                                            saveToPagesData(id, updatedSections);
                                          }
                                        }
                                      } : undefined
                                    }
                                    onDeleteReason={section.type === 'WhyChooseUs' ? 
                                      (index: number) => {
                                        const updatedSections = [...sections];
                                        const currentSection = updatedSections[idx];
                                        if (currentSection.props.reasons && Array.isArray(currentSection.props.reasons)) {
                                          currentSection.props.reasons.splice(index, 1);
                                          setSections(updatedSections);
                                          if (id) {
                                            saveToPagesData(id, updatedSections);
                                          }
                                        }
                                      } : undefined
                                    }
                                  />
                                )}
                                <div className="absolute top-2 right-2 bg-blue-600 text-white px-2 py-1 rounded text-xs font-bold">
                                  {id} - {section.type}
                                </div>
                              </div>
                              {/* محرر الخصائص */}
                              {editingIdx === idx && (
                                <div className="bg-gray-50 border rounded p-4 mt-4">
                                  {renderEditForm(section.type, editProps)}
                                  <div className="flex gap-2 mt-4">
                                    <button onClick={() => handleSaveEdit(editProps)} className="bg-green-600 text-white px-4 py-1 rounded">حفظ</button>
                                    <button onClick={handleCancelEdit} className="bg-gray-300 text-gray-800 px-4 py-1 rounded">إلغاء</button>
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                        </Draggable>
                      );
                    })}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          )}
        </div>

        {/* محرر الخصائص المتقدم */}
        {showPropsEditor && (
          <SectionPropsEditor
            sectionType={editingSectionType}
            currentProps={editProps}
            onSave={handleSaveEdit}
            onCancel={handleCancelEdit}
            language={language}
          />
        )}

        {/* المحرر المباشر */}
        {showInlineEditor && editingIdx !== null && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50">
            <div className="w-full h-full flex items-center justify-center p-8">
              <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-hidden">
                {/* Header */}
                <div className="flex items-center justify-between p-4 border-b">
                  <h3 className="text-lg font-semibold text-gray-900">
                    {language === 'ar' ? `تحرير ${sectionLibrary.find(s => s.type === sections[editingIdx].type)?.label || sections[editingIdx].type}` : `Edit ${sectionLibrary.find(s => s.type === sections[editingIdx].type)?.label || sections[editingIdx].type}`}
                  </h3>
                  <button
                    onClick={() => {
                      setShowInlineEditor(false);
                      setEditingIdx(null);
                    }}
                    className="text-gray-500 hover:text-gray-700"
                  >
                    <FaTimes className="w-5 h-5" />
                  </button>
                </div>

                {/* Content */}
                <div className="p-6 overflow-y-auto max-h-[calc(90vh-80px)]">
                  <InlineEditor
                    onSave={(data) => {
                      console.log('Inline editor data:', data);
                      
                      // تحديث البيانات بناءً على سياق التعديل
                      if (editingIdx !== null && data.sectionIndex !== undefined) {
                        const updatedSections = [...sections];
                        const currentSection = updatedSections[data.sectionIndex];
                        
                        if (currentSection && data.editingContext) {
                          const { elementType, elementKey } = data.editingContext;
                          
                          // تحديث البيانات بناءً على نوع العنصر
                          switch (elementType) {
                            case 'text':
                              if (data.textContent && elementKey) {
                                // تحديث النص في البيانات
                                if (elementKey.includes('.')) {
                                  // للبيانات المتداخلة مثل headline.ar أو points.0.ar
                                  const keys = elementKey.split('.');
                                  let current = currentSection.props;
                                  
                                  // التعامل مع المصفوفات
                                  for (let i = 0; i < keys.length - 1; i++) {
                                    const key = keys[i];
                                    const nextKey = keys[i + 1];
                                    
                                    // إذا كان المفتاح التالي رقم، فهذا مصفوفة
                                    if (!isNaN(parseInt(nextKey))) {
                                      if (!current[key] || !Array.isArray(current[key])) {
                                        current[key] = [];
                                      }
                                      // إذا لم يكن العنصر موجود في المصفوفة، أنشئه
                                      if (!current[key][parseInt(nextKey)]) {
                                        current[key][parseInt(nextKey)] = {};
                                      }
                                      current = current[key][parseInt(nextKey)];
                                      i++; // تخطي المفتاح التالي لأنه رقم
                                    } else {
                                      if (!current[key]) {
                                        current[key] = {};
                                      }
                                      current = current[key];
                                    }
                                  }
                                  
                                  // تحديث القيمة النهائية
                                  const lastKey = keys[keys.length - 1];
                                  if (!isNaN(parseInt(lastKey))) {
                                    // إذا كان المفتاح الأخير رقم، فهذا عنصر في مصفوفة
                                    const arrayKey = keys[keys.length - 2];
                                    const index = parseInt(lastKey);
                                    if (current[arrayKey] && Array.isArray(current[arrayKey])) {
                                      current[arrayKey][index] = data.textContent;
                                    }
                                  } else {
                                    current[lastKey] = data.textContent;
                                  }
                                } else {
                                  // للبيانات البسيطة
                                  currentSection.props[elementKey] = data.textContent;
                                }
                              }
                              break;
                              
                            case 'image':
                              if (data.imageAlt && elementKey === 'backgroundAlt') {
                                // تحديث alt text للصورة الخلفية
                                currentSection.props.backgroundAlt = data.imageAlt;
                              } else if (elementKey === 'image' || elementKey === 'backgroundImage') {
                                // تحديث رابط الصورة
                                currentSection.props[elementKey] = data.imageAlt || currentSection.props[elementKey];
                              } else if (elementKey && elementKey.startsWith('images.')) {
                                // تحديث صورة في مصفوفة الصور
                                const imageIndex = parseInt(elementKey.split('.')[1]);
                                if (!isNaN(imageIndex) && currentSection.props.images) {
                                  currentSection.props.images[imageIndex] = data.imageAlt || currentSection.props.images[imageIndex];
                                }
                              }
                              break;
                              
                            case 'icon':
                              if (elementKey && data.iconStyles) {
                                // تحديث خصائص الأيقونة
                                if (!currentSection.props.iconStyles) {
                                  currentSection.props.iconStyles = {};
                                }
                                currentSection.props.iconStyles = {
                                  ...currentSection.props.iconStyles,
                                  ...data.iconStyles
                                };
                              }
                              break;
                              
                            case 'background':
                              if (elementKey && data.backgroundStyles) {
                                // تحديث خصائص الخلفية
                                currentSection.props[elementKey] = data.backgroundStyles;
                              }
                              break;
                          }
                          
                          // تحديث خصائص النص إذا كانت موجودة
                          if (data.textStyles && elementKey) {
                            if (!currentSection.props.textStyles) {
                              currentSection.props.textStyles = {};
                            }
                            currentSection.props.textStyles[elementKey] = data.textStyles;
                          }
                        }
                        
                        setSections(updatedSections);
                        
                        // حفظ التغييرات في pagesData
                        if (id) {
                          saveToPagesData(id, updatedSections);
                        }
                      }
                      
                      setShowInlineEditor(false);
                      setEditingIdx(null);
                    }}
                    onCancel={() => {
                      setShowInlineEditor(false);
                      setEditingIdx(null);
                    }}
                    onDelete={handleDeleteElement}
                    language={language}
                    sectionIndex={editingIdx}
                    sectionType={editingIdx !== null ? sections[editingIdx]?.type : undefined}
                  >
                    <div className={`${language === 'ar' ? 'font-cairo' : 'font-montserrat'}`} dir={language === 'ar' ? 'rtl' : 'ltr'}>
                      {(() => {
                        const section = sections[editingIdx];
                        const SectionComponent = sectionComponents[section.type];
                        if (!SectionComponent) return null;
                        return <SectionComponent language={language} {...section.props} />;
                      })()}
                    </div>
                  </InlineEditor>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default AdminPageBuilder;